export default __webpack_public_path__ + "static/img1-6bf2c4cbabd3e06cdf92415f11165074.jpg";